import React, {useState, useEffect, useRef} from 'react';
import {textTruncateByLength, numberWithCommas} from 'utils/other';
import SourcePreviewModal from './modals/SourcePreviewModal';
import InputField from '../CreateFeed/Inputs/components/InputField';
import Loader from 'components/Loader';
import SpinnerButton from 'components/SpinnerButton';
import AlertRulesModal from 'components/AlertRulesModal/Info';
import useClickOutside from 'Helpers/useClickOutside';
// import ReactTooltip from 'react-tooltip';
// import {usePopperTooltip} from 'react-popper-tooltip';
import Tooltip from 'components/Tooltip';

const SourceListItem = ({source, index, deleteSource, handleSubmitGoogleOzmosysChange, preventActions}) => {
    const inputRef = useRef(null);

    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [alertRulesModalOpen, setAlertRulesModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [titleValue, setTitleValue] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const togglePreviewModal = () => {
        if(preventActions) return;
        setPreviewModalOpen(prevState => !prevState);
    }
    const toggleAlertRulesModal = () => setAlertRulesModalOpen(prevState => !prevState);
    const toggleEditMode = () => {
        if(preventActions) return;
        setEditMode(prevState => !prevState);
    };

    useEffect(() => {
        if(source.type === 'google_ozmosys') {
            source.name ? setTitleValue(source.name) : setTitleValue(source.title);
        }
    }, []);

    useEffect(() => {
        if(source.type === 'google_ozmosys') {
            source.name ? setTitleValue(source.name) : setTitleValue(source.title);
        }
    }, [editMode]);

    useClickOutside(inputRef, () => {
        if(inputRef) {
            console.log(alertRulesModalOpen);
            editMode && !alertRulesModalOpen && setEditMode(false);
        }
    });

    const handleFocus = (e) => {
        e.currentTarget.select();
    };

    const handleTitleChange = () => {
        if(titleValue !== source.name || titleValue !== source.sourceName) {
            setSubmitting(true);
            let failedCallback = () => {
                setSubmitting(false);
                setEditMode(false);
            };
            handleSubmitGoogleOzmosysChange(source.id, titleValue, failedCallback);
        }
    };

    const handleIconDisplay = () => {
        switch(source.type) {
            case 'twitter':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#1DA1F2'}}>
                        <i className="fab fa-twitter"/>
                    </div>
                );
            case 'facebook':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#4267B2'}}>
                        <i className="fab fa-facebook-f"/>
                    </div>
                );
            case 'youtube':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#FF0000'}}>
                        <i className="fab fa-youtube"/>
                    </div>
                );
            case 'instagram':
                return (
                    <div className="adding-media-icon filter-icon--instagram">
                        <i className="fab fa-instagram"/>
                    </div>
                );
            case 'rss':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#ee802f'}}>
                        <i className="fas fa-rss"/>
                    </div>
                );
            case 'google_ozmosys':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#314784'}}>
                        <i className="fa fa-globe"/>
                    </div>
                );
            case 'web':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#6E7179'}}>
                        <i className="fa fa-cog"/>
                    </div>
                );
            default:
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#4267B2'}}>
                        <i className="fa fa-newspaper-o"/>
                    </div>
                );

        }
    };

    const handleInfluenceDisplay = () => {
        if(!source.hasOwnProperty('influence')) return null;
        if(source.type === 'web' || source.type === 'rss' || source.type === 'google_ozmosys') return null;
        if(source.type === 'twitter') {
            if(source.pageId === null || source.twitterPageId === null) return null;
        }
        return (
            <div>&nbsp;{`(${numberWithCommas(source.influence)} ${handleInfluenceSuffix(source.influence)})`}</div>
        );
    };

    const handleInfluenceSuffix = (influence) => {
        switch(source.type) {
            case 'twitter':
                return influence === 1 ? 'Follower' : 'Followers';
            case 'facebook':
                return influence === 1 ? 'person likes this' : 'people like this';
            case 'youtube':
                return influence === 1 ? 'Subscriber' : 'Subscribers';
            case 'instagram':
                return influence === 1 ? 'Follower' : 'Followers';
            case 'rss':
                return '';
            case 'web':
                return '';
            case 'google_ozmosys':
                return '';
            default:
                return '';
        }
    };

    // const {
    //     getArrowProps,
    //     getTooltipProps,
    //     setTooltipRef,
    //     setTriggerRef,
    //     visible,
    // } = usePopperTooltip();


    return (
        <div key={index + source.name}
             className="adding-item-header"
             style={{cursor: 'default', padding: '10px 0rem'}}
        >
            {previewModalOpen &&
            <SourcePreviewModal
                isOpen={previewModalOpen}
                toggle={togglePreviewModal}
                type={source.type}
                source={source}
                handleIconDisplay={handleIconDisplay}
                handleInfluenceDisplay={handleInfluenceDisplay}
                handleInfluenceSuffix={handleInfluenceSuffix}
            />
            }
            <div className="d-flex w-100">
                {handleIconDisplay()}
                {editMode ?
                    <div className="d-flex flex-grow-1 justify-content-between align-items-center">
                        <div className="w-100 d-flex flex-column align-items-start" style={{marginLeft: '15px'}}
                             ref={inputRef}>
                            <div className="d-flex w-100">
                                <InputField
                                    onSubmit={handleTitleChange}
                                    inputPlaceholder="Source name"
                                    showSubmitGlass={false}
                                    parrentDataHandling={true}
                                    value={titleValue}
                                    handleChange={setTitleValue}
                                    // onBlur={toggleEditMode}
                                    highlightOnFocus
                                />
                                <SpinnerButton
                                    onClick={handleTitleChange}
                                    title="Save"
                                    submitting={submitting}
                                    minWidth="91px"
                                    className="ml-2"
                                />

                            </div>
                            <div className="w-100 d-flex">
                                <AlertRulesModal isOpen={alertRulesModalOpen} toggle={toggleAlertRulesModal}/>
                                <div className="placeholder ml-2" style={{width: '91px'}}/>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="d-flex flex-grow-1 justify-content-between align-items-center">
                        <div style={{
                            marginLeft: '15px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}>
                            <div style={{fontSize: '16px', fontWeight: '700'}}>
                                {submitting ?
                                    titleValue
                                    :
                                    source.name ?
                                        textTruncateByLength(source.name, 50) :
                                        source.title ? textTruncateByLength(source.title, 50) :
                                            source.screenName ? textTruncateByLength(source.screenName, 50) : ''}
                            </div>
                            {
                                (source.type !== 'twitter' ||
                                    (source.type === 'twitter' && (source.twitterPageId || source.pageId))
                                )
                                &&
                                <div style={{display: 'flex'}}>
                                    {(source.screenName || source.name) &&
                                    <a
                                        style={{textDecoration: 'underline'}}
                                        href={source.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {source.screenName ? textTruncateByLength(source.screenName, 50) :
                                            textTruncateByLength(source.name, 50)}
                                    </a>
                                    }
                                    {handleInfluenceDisplay()}
                                </div>
                            }
                        </div>
                        {/*{submitting ?*/}
                        {/*    <div className="d-flex justify-content-end" style={{minWidth: '60px'}}>*/}
                        {/*        <Loader small/>*/}
                        {/*    </div>*/}
                        {/*    :*/}
                        <div className="d-flex justify-content-end" style={{minWidth: '60px'}}>
                            {source.type === 'google_ozmosys' &&
                            <>
                                <Tooltip placement="top" trigger="click" tooltip="Edit">
                                    <i
                                        onClick={toggleEditMode}
                                        className="feedsActions fas fa-pencil-alt"
                                        style={{marginRight: '5px'}}
                                    />
                                </Tooltip>
                            </>
                            }
                            <Tooltip placement="top" trigger="click" tooltip="Preview">
                                <i
                                    onClick={togglePreviewModal}
                                    className="feedsActions far fa-eye"
                                    style={{marginRight: '5px'}}
                                />
                            </Tooltip>
                            <Tooltip placement="top" trigger="click" tooltip="Delete">
                                <i
                                    onClick={() => deleteSource(source.id)}
                                    className="feedsActions fas fa-trash-alt"
                                />
                            </Tooltip>
                        </div>
                        {/*}*/}
                    </div>
                }
            </div>
        </div>
    );
};

export default SourceListItem;
